import { history } from "../../src/index";

import * as types from '../constants/esignaturedetails';
import * as toasterTypes from '../constants/ActionTypes';
import * as esignaturedetailsApi from '../api/esignaturedetails';

export function geteSignatureDetails(id) {
    // console.log("geteSignatureDetails action call");
    return dispatch => {
        dispatch({ type: types.FETCH_ESIGNATURE_REQUEST });
        esignaturedetailsApi.geteSignature(id)
            .then(function (response) {
                // console.log("geteSignatureDetails", response)
                dispatch({ type: types.FETCH_ESIGNATURE_REQUEST_COMPLETED, data: response.data });
            })
            .catch(function (err) {
                // console.log("geteSignatureDetails Error", err)
                dispatch({ type: types.FETCH_ESIGNATURE_REQUEST_ERROR });
            });
    }
}

export function geteSignatureDetailsList(committee_id) {
    // console.log("geteSignatureDetailsList action call");
    return dispatch => {
        dispatch({ type: types.FETCH_ESIGNATURE_LIST_REQUEST });
        esignaturedetailsApi.geteSignatureList(committee_id)
            .then(function (response) {
                // console.log("geteSignatureDetailsList", response)
                dispatch({ type: types.FETCH_ESIGNATURE_LIST_REQUEST_COMPLETED, data: response.data });
            })
            .catch(function (err) {
                // console.log("geteSignatureDetailsList Error", err)
                dispatch({ type: types.FETCH_ESIGNATURE_LIST_REQUEST_ERROR });
            });
    }
}

export function addeSignatureDetails(objModel) {
    // console.log("addeSignatureDetails action call",objModel);
    return dispatch => {
        dispatch({ type: types.ADD_ESIGNATURE_REQUEST });
        esignaturedetailsApi.addeSignature(objModel)
            .then(function (response) {
                // console.log("addeSignatureDetails action succ", response)
                if (response.status == 200) {
                    dispatch({ type: types.ADD_ESIGNATURE_REQUEST_COMPLETED });
                    dispatch({ type: toasterTypes.DISPLAY_SUCCESS, message: "Saved Successfully" });
                    history.push('/esignature/esignature-list/');
                }
                dispatch({ type: types.ADD_ESIGNATURE_RESET });
            })
            .catch(function (err) {
                // console.log("addeSignatureDetails action err", err)
                dispatch({ type: types.ADD_ESIGNATURE_REQUEST_ERROR });
            });
    }
}

export function updateeSignatureDetails(objModel) {
    // console.log("updateeSignatureDetails action call",objModel);
    return dispatch => {
        dispatch({ type: types.ADD_ESIGNATURE_REQUEST });
        esignaturedetailsApi.updateeSignature(objModel)
            .then(function (response) {
                // console.log("updateeSignatureDetails action succ", response)
                if (response.status == 200) {
                    dispatch({ type: types.ADD_ESIGNATURE_REQUEST_COMPLETED });
                    dispatch({ type: toasterTypes.DISPLAY_SUCCESS, message: "Saved Successfully" });
                    history.push('/esignature/esignature-list');
                }
                dispatch({ type: types.ADD_ESIGNATURE_RESET });
            })
            .catch(function (err) {
                // console.log("updateeSignatureDetails action err", err)
                dispatch({ type: types.ADD_ESIGNATURE_REQUEST_ERROR });
            });
    }
}

export function updateExistingFile(id, objModel) {
    // console.log("updateFileDetails action call",objModel);
    return dispatch => {
        dispatch({ type: types.UPDATE_FILE_REQUEST });
        esignaturedetailsApi.updateExistingFile(id, objModel)
            .then(function (response) {
                // console.log("updateFileDetails action succ", response)
                if (response.status == 200) {
                    dispatch({ type: types.UPDATE_FILE_REQUEST_COMPLETED });
                    dispatch({ type: toasterTypes.DISPLAY_SUCCESS, message: "Updated Successfully" });
                    // history.push('/document/add-document/' + id);
                }
            })
            .catch(function (err) {
                // console.log("updateFileDetails action err", err)
                dispatch({ type: types.UPDATE_FILE_REQUEST_ERROR });
            });
    }
}

export function deleteeSignatureDetails(id) {
    // console.log("deleteeSignatureDetails action call",objModel);
    return dispatch => {
        dispatch({ type: types.ADD_ESIGNATURE_REQUEST });
        esignaturedetailsApi.deleteeSignature(id,status)
            .then(function (response) {
                // console.log("deleteeSignatureDetails action succ", response)
                if (response.status == 200) {
                    dispatch({ type: types.ADD_ESIGNATURE_REQUEST_COMPLETED });
                    dispatch({ type: toasterTypes.DISPLAY_SUCCESS, message: "Saved Successfully" });
                    history.push('/esignature/esignature-list');
                }
                dispatch({ type: types.ADD_ESIGNATURE_RESET });
            })
            .catch(function (err) {
                // console.log("deleteeSignatureDetails action err", err)
                dispatch({ type: types.ADD_ESIGNATURE_REQUEST_ERROR });
            });
    }
}



// WEBPACK FOOTER //
// ./actions/esignaturedetails.js